import React from "react";
import "../screens/registration.css";
import { OnlineTrainingConstant } from "../helpers/constants";


const changeLabelCase = (label) => {

  switch (label) {
    case "Jawan Pakistan Academy":
      return "Onsite Jauhar Campus"
    case "SAIMS ( WOW )":
      return "Onsite Hussainabad Campus"
    case OnlineTrainingConstant.key:
      return OnlineTrainingConstant.label
    default:
      return label
  }
}
let AppDropDown = (props) => {
  const { labelName, propsArr, onChange, value } = props;
  return (
    <>
      <label style={{ fontWeight: "bold", color: "#585962" }} htmlFor="inputState">
        {labelName}
      </label>
      <span style={{ paddingLeft: 2, color: "red" }} className="required">
        *
      </span>
      <select id="inputState" value={value} onChange={onChange}>
        <option key={'random000101'} value="">Select Option</option>
        {propsArr.length != 0
          ? propsArr
            .filter((val) => {
              return val != null;
            })
            .map((e, i) => {
              return (
                <option key={i} value={e}>
                  {changeLabelCase(e)}
                </option>
              );
            })
          : null}
      </select>
    </>
  );
};
export default AppDropDown;
